import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ContentBuilderColorPipe } from '@core/pipes/content-builder-color.pipe';
import { ButtonAtomComponent } from '@shared/atoms/button-atom/button-atom.component';
import { CallComponentMethodPipe } from '@shared/pipes/call-component-method/call-component-method.pipe';
import { KioskCategoryStepperComponent } from '@shared/atoms/kiosk/kiosk-product-stepper/kiosk-category-stepper.component';
import { KioskSimpleProductStepperComponent } from '@shared/atoms/kiosk/kiosk-product-stepper/kiosk-simple-product-stepper.component';
import { KioskProductCardAtomComponent } from '@shared/atoms/kiosk/kiosk-product-cards/kiosk-product-card-atom/kiosk-product-card-atom.component';
import { KioskStepperNavigationAtomComponent } from '@shared/atoms/kiosk/kiosk-stepper-navigation-atom/kiosk-stepper-navigation-atom.component';
import { KioskProductDetailsOrganismComponent } from '@shared/atoms/kiosk/kiosk-product-details-organism/kiosk-product-details-organism.component';
import { KioskSimpleProductDetailsOrganism } from '@shared/atoms/kiosk/kiosk-simple-product-details-organism/kiosk-simple-product-details-organism.component';
import { KioskSelectDeclinableProductsComponent } from '@shared/atoms/kiosk/kiosk-select-declinable-products/kiosk-select-declinable-products.component';
import { KioskSelectionGroupWrapperComponent } from '@shared/blocks/kiosk/kiosk-selection-group-wrapper-atom/kiosk-selection-group-wrapper-atom.component';
import { KioskSelectProductCategoryOrganismComponent } from '@shared/atoms/kiosk/kiosk-select-product-category-organism/kiosk-select-product-category-organism.component';
import { KioskSelectAdditionsProductOrganismComponent } from '@shared/atoms/kiosk/kiosk-select-addition-product-organism/kiosk-select-addition-product-organism.component';
import { SimpleProductCardOrganismComponent } from '@shared/atoms/kiosk/kiosk-simple-product-card-organism/kiosk-simple-product-card-organism.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    ContentBuilderColorPipe,
    ButtonAtomComponent,
    CallComponentMethodPipe,
    KioskCategoryStepperComponent,
    KioskSimpleProductStepperComponent,
    KioskProductCardAtomComponent,
    KioskProductDetailsOrganismComponent,
    KioskSimpleProductDetailsOrganism,
    KioskSelectDeclinableProductsComponent,
    KioskSelectionGroupWrapperComponent,
    KioskSelectProductCategoryOrganismComponent,
    KioskSelectAdditionsProductOrganismComponent,
    SimpleProductCardOrganismComponent,
  ],
  declarations: [KioskStepperNavigationAtomComponent],
  exports: [
    KioskStepperNavigationAtomComponent,
    KioskProductDetailsOrganismComponent,
    ContentBuilderColorPipe,
  ],
})
export class KioskProductDetailsBlockDepsModule {}
